import * as yup from 'yup'

/**
 * At least one scope. Enforced client-side only: the backend decorates `scopes` with
 * `@IsNotEmpty()`, but class-validator's `isNotEmpty` only tests against `''`, `null` and
 * `undefined`, so an empty array passes server-side validation. A client with no scopes can
 * authenticate and reach nothing, which is never what an admin means to create.
 */
export const oauthClientFormValidator = yup.object({
  scopes: yup.array().of(yup.string().required()).min(1, 'Select at least one scope'),
})
